import React, { useState } from "react"

import { applyImageCloudinaryTransforms } from "utils/applyCloudinaryTransforms"

import {
  Wrapper,
  StyledHeroContent,
  List,
  ItemContainer,
  ItemHeader,
  ItemLogo,
  ItemTitleAndSubtitle,
  ItemTitle,
  ItemSubtitle,
  ItemSubtitleIcon,
  DesktopWrapper,
  MobileWrapper,
  ItemBody,
  MoreLessButton,
  CheckIconWrapper,
  CheckIcon,
} from "./styles"

const MultiListSignupForm = ({
  className,
  elRef,
  preheading,
  heading,
  subheading,
  baseForm,
  signupForms,
  selectedItems,
  onItemClick,
}) => {
  return (
    <Wrapper className={className} ref={elRef}>
      <StyledHeroContent preheading={preheading} heading={heading} subheading={subheading} />
      <List>
        {signupForms.map((signupForm, idx) => (
          <Item
            key={signupForm.id}
            {...signupForm}
            isSelected={selectedItems[idx]}
            onClick={() => onItemClick(idx)}
          />
        ))}
      </List>
      {baseForm}
    </Wrapper>
  )
}

const Item = ({ heading, headingLogo, bodyText, ...props }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const handleExpandCollapseClick = (event) => {
    event.stopPropagation()
    setIsExpanded(!isExpanded)
  }

  const title = heading.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")
  const body = bodyText.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")

  const renderBody = () => {
    if (body.length <= 100) {
      return body
    }

    if (isExpanded) {
      return (
        <>
          {body}... <MoreLessButton onClick={handleExpandCollapseClick}>Show less</MoreLessButton>
        </>
      )
    }

    return (
      <>
        {body.substring(0, 100)}...{" "}
        <MoreLessButton onClick={handleExpandCollapseClick}>Learn more</MoreLessButton>
      </>
    )
  }

  return (
    <ItemContainer {...props}>
      <ItemHeader>
        <ItemLogo
          src={applyImageCloudinaryTransforms(headingLogo[0].secure_url, "fl_sanitize")}
          alt={title}
          title={title}
        />
        <ItemTitleAndSubtitle>
          <ItemTitle>{title}</ItemTitle>
        </ItemTitleAndSubtitle>
      </ItemHeader>
      <DesktopWrapper>
        <ItemBody>{body}</ItemBody>
      </DesktopWrapper>
      <MobileWrapper>
        <ItemBody>{renderBody()}</ItemBody>
      </MobileWrapper>
      <CheckIconWrapper isSelected={props.isSelected}>
        <CheckIcon id="check" width={9} height={9} />
      </CheckIconWrapper>
    </ItemContainer>
  )
}

export default MultiListSignupForm
